import { BASE_INFO_FIELD_KEY_LIST } from '../../capabilities/base-info/fieldKeys';
import { MS_OTHER_FIELD_KEY_LIST } from '../../capabilities/model-subscription-other/fieldKeys';
import { MS_PROVIDER_FIELD_KEY_LIST } from '../../capabilities/model-subscription-provider/fieldKeys';

export const MS_FIELD_KEYS = [...BASE_INFO_FIELD_KEY_LIST, ...MS_PROVIDER_FIELD_KEY_LIST, ...MS_OTHER_FIELD_KEY_LIST] as const;

export type MsFieldKey = (typeof MS_FIELD_KEYS)[number];
